import { NestedFormController as BaseNestedFormController } from 'stimulus-library'
/**
 * @description Specialize nested form controller to generate observable events when adding/removing rows.
 */
export default class NestedFormController extends BaseNestedFormController {
  add(event) {
    super.add(event)
    this.element.dispatchEvent(new CustomEvent('nested-form:add', { bubbles: true, detail: { event } }))
  }

  remove(event) {
    super.remove(event)
    this.element.dispatchEvent(new CustomEvent('nested-form:remove', { bubbles: true, detail: { event } }))
  }

  _generateID() {
    return this.element.querySelectorAll(`.${this.wrapperClassValue}`).length
  }
}